import * as React from "react";
import {Conductor} from "@models/conductor";
import ConductorsTable from "@components/conductors/Table";
import {Button, Card} from "antd";
import {FormattedMessage} from "react-intl";
import SearchConductorsComponent from "@components/conductors/Search";
import {NavLink} from "react-router-dom";
import whitListData from "@hocs/withListData";
import conductorApi from "@api/conductor";
import withPaginationComponent from "@hocs/withPaginationComponent";



interface PropsFromHoc {
  data          :Conductor[];
  isFetched     : boolean;
  currentPage   : number;
  search        : (params: object | null) => void;
  onDeleteItem  : (id:string) => void;
}


type AllProps = PropsFromHoc ;

const ConductorsIndexPage: React.FC<AllProps> = (props) => {
  const {data, isFetched, currentPage, search} = props;

  const deleteConductor = (item: Conductor): any => {
    const {onDeleteItem} = props;
    conductorApi.delete({
        params: {
          conductor_id : item.id
        }
      })
      .then(() => {
        onDeleteItem(item.id)
      })
      .catch(error => console.log(error))
  };

  return (
    <div>
      <div className={`toggle-button-wrapper`}>
        <NavLink to={`/conductors/create`}>
          <Button type={"primary"}>
            <FormattedMessage
              id="app.new_conductor"
              defaultMessage={`Create Conductor`}
            />
          </Button>
        </NavLink>
      </div>
      <div className={"page-table-wrapper"}>
        <Card className={`page-table-header`} bordered={false}>
          <SearchConductorsComponent search={search}/>
        </Card>

        <ConductorsTable
          data={data}
          currentPage={currentPage}
          rowKey={record => record.id}
          deleteFn={deleteConductor}
          loading={!isFetched}
        />
      </div>
    </div>
  );
};


export default whitListData(
  withPaginationComponent(ConductorsIndexPage),
  {
    fetchRequest: conductorApi.getList,
    paginationOnScroll: false
  }
);
